import { render, staticRenderFns } from "./VehicleLookupSideMenu.vue?vue&type=template&id=72dab37a"
import script from "./VehicleLookupSideMenu.vue?vue&type=script&lang=js"
export * from "./VehicleLookupSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports